import { Stack, StackProps } from '@mui/material';
import { useConnection } from 'modules/auth';
import { ConnectWalletBtn } from 'modules/common/components/ConnectWalletBtn';
import { ConnectedWallet } from './components/ConnectedWallet';
import { NetworkSelect } from './components/NetworkSelect';

interface IConnectProps extends StackProps {}

export function Connect(props: IConnectProps): JSX.Element {
  const { isConnected } = useConnection();

  return isConnected ? (
    <Stack direction="row" gap={1.5} {...props}>
      <NetworkSelect sx={{ display: { xs: 'none', sm: 'flex' } }} />

      <ConnectedWallet />
    </Stack>
  ) : (
    <ConnectWalletBtn size="small" />
  );
}
